import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68a2b006"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "KeyReply" }
const _hoisted_2 = { class: "statitiscal" }
const _hoisted_3 = { class: "inner" }
const _hoisted_4 = { class: "total" }
const _hoisted_5 = { class: "inner_number" }
const _hoisted_6 = { class: "total" }
const _hoisted_7 = { class: "inner_number" }

import { searchFormConfig } from './config/search.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { contentTableConfig } from './config/content.config'
import PageContent from '@/components/PageContent.vue'
import { usePageModal } from '@/hooks/usePageModal'
import { modalConfig } from './config/modal.config'
import { onMounted, reactive, ref } from 'vue'
import { getBeforeDate } from '@/utils/utils'
import { useStore } from '@/store'
import { getListData } from '@/service/main/system'
import { Excel, mergeListType } from '@/utils/ExcelJs'


export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

var queryParam = {
  date: [getBeforeDate('today'), new Date().toISOString().slice(0, 10)]
}

const store = useStore()
store.commit('system/changeQueyryInfo', queryParam)

const getTeachers = async () => {
  let data = await getListData('/main/keyReply/queryDic?type=teacher', {})

  const teachers = searchFormConfig.formItems.find(
    (item: any) => item.field === 'teacher'
  )
  teachers!.options = data.map((item: any) => {
    return { title: item, value: item }
  })

  const teachersModal = modalConfig.formItems.find(
    (item: any) => item.field === 'teacher'
  )
  teachersModal!.options = data.map((item: any) => {
    return { title: item, value: item }
  })
}

const getClassnames = async () => {
  let data = await getListData('/main/keyReply/queryDic?type=class', {})

  const classnames = searchFormConfig.formItems.find(
    (item: any) => item.field === 'classname'
  )
  classnames!.options = data.map((item: any) => {
    return { title: item, value: item }
  })

  const classnamesModal = modalConfig.formItems.find(
    (item: any) => item.field === 'classname'
  )
  classnamesModal!.options = data.map((item: any) => {
    return { title: item, value: item }
  })
}

const total5 = ref(0)
const totalAll = ref(0)
let timeRanges: any = []
const getCounters = async () => {
  const queryInfo = store.state.system.queryInfo
  let data = await getListData('/main/keyReply/queryCount', queryInfo)
  total5.value = data.total5
  totalAll.value = data.totalAll
  const hasTime = contentTableConfig.propList.some((item) =>
    item.prop?.includes('time')
  )
  if (!hasTime) {
    data.timeRange.forEach((item: any, index: number) => {
      let obj = {
        prop: 'timeCounters',
        childProp: 'time' + (index + 1),
        label: item,
        sortable: true,
        minWidth: '100',
        sortMethod: function (a: any, b: any) {
          console.log(a)
          return (
            parseInt(a.timeCounters['time' + (index + 1)]) -
            parseInt(b.timeCounters['time' + (index + 1)])
          )
        }
      }
      timeRanges.push(obj)
    })
    contentTableConfig.propList.splice(1, 0, ...timeRanges)
  }
  console.log(contentTableConfig.propList)
}

onMounted(() => {
  getTeachers()
  getClassnames()
})

getCounters()

const otherInfo = reactive({
  url: ''
})
const modalTitle = ref('新增')

const newCb = () => {
  modalTitle.value = '新增关键词'
}

const editCb = () => {
  modalTitle.value = '修改关键词'
}

const resetCb = () => {
  return queryParam
}

const searchCb = () => {}

const afterSearchCb = () => {
  getCounters()
}

const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch(
  resetCb,
  searchCb,
  afterSearchCb
)
const [pageModalRef, defaultInfo, handleNewData, handleEditData] = usePageModal(
  newCb,
  editCb
)

const getExportData = async () => {
  let queryInfo = store.state.system.queryInfo
  return await getListData('/main/keyReply/queryExportData', queryInfo)
}

const ts2str = (ts: any) => {
  let date = new Date(parseInt(ts))
  let Year = date.getFullYear()
  let Moth =
    date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  let Day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  let Hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  let Minute =
    date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  let Second =
    date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  let GMT =
    Year + '-' + Moth + '-' + Day + ' ' + Hour + ':' + Minute + ':' + Second
  return GMT
}

const handleDownload = () => {
  getExportData().then((res) => {
    let customHeader = [
      '关键词',
      timeRanges[0].label,
      timeRanges[1].label,
      timeRanges[2].label,
      timeRanges[3].label,
      timeRanges[4].label,
      '五个时间段累计',
      '全天累计',
      '老师',
      '节目',
      '五个时间段总计',
      '全天总计'
    ]
    let header = [
      'keyword',
      timeRanges[0].childProp,
      timeRanges[1].childProp,
      timeRanges[2].childProp,
      timeRanges[3].childProp,
      timeRanges[4].childProp,
      'sum5',
      'sumAll',
      'teacher',
      'classname',
      'totalSum5',
      'totalSumAll'
    ]
    let mergeList: mergeListType[] = [
      {
        startRow: 1,
        endRow: res.length,
        startColumn: header.length - 1,
        endColumn: header.length - 1
      },
      {
        startRow: 1,
        endRow: res.length,
        startColumn: header.length,
        endColumn: header.length
      }
    ]
    res.forEach((item: any) => {
      item.time1 = item.timeCounters.time1
      item.time2 = item.timeCounters.time2
      item.time3 = item.timeCounters.time3
      item.time4 = item.timeCounters.time4
      item.time5 = item.timeCounters.time5
      item.totalSum5 = total5.value
      item.totalSumAll = totalAll.value
    })
    // 文件名
    let filename = ts2str(new Date().getTime()).replaceAll(/:| |-/gi, '')
    let queryInfo = store.state.system.queryInfo
    const excel = new Excel()
    excel.exportExcel({
      name:
        '关键词回复统计-' +
        queryInfo.date[0] +
        '-' +
        queryInfo.date[1] +
        '-' +
        filename,
      title:
        '关键词回复统计-' +
        queryInfo.date[0] +
        '-' +
        queryInfo.date[1] +
        '-' +
        filename,
      data: reactive(res),
      header,
      customHeader,
      mergeList
    })
  })
}

const handleSortChange = (value: any) => {
  let orderBy = value.prop
  console.log(value)
  if(value.prop == 'timeCounters'){
    orderBy = 'time' + value.column.no
  }
  store.commit('system/changeOrderInfo', {
    orderBy: orderBy,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageModal = _resolveComponent("PageModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createTextVNode("五个时间段总计: "),
          _createElementVNode("em", _hoisted_5, _toDisplayString(total5.value), 1)
        ]),
        _createElementVNode("span", _hoisted_6, [
          _createTextVNode("全天总计: "),
          _createElementVNode("em", _hoisted_7, _toDisplayString(totalAll.value), 1)
        ])
      ])
    ]),
    _createVNode(PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "keyReply",
      deleteTip: "确认删除此关键词吗？",
      onNewBtnClick: _unref(handleNewData),
      onEditBtnClick: _unref(handleEditData),
      onExportStatistic: handleDownload,
      onSortChange: handleSortChange
    }, null, 8, ["contentTableConfig", "onNewBtnClick", "onEditBtnClick"]),
    _createVNode(_component_PageModal, {
      ref_key: "pageModalRef",
      ref: pageModalRef,
      defaultInfo: _unref(defaultInfo),
      modalConfig: _unref(modalConfig),
      title: modalTitle.value,
      pageName: "keyReply",
      otherInfo: otherInfo
    }, null, 8, ["defaultInfo", "modalConfig", "title", "otherInfo"])
  ]))
}
}

})